import * as AppearanceGlobalAssetsActions from '../store/actions/appearanceGlobalAssetsActions';
import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  actionCreate: AppearanceGlobalAssetsActions.createAppearanceGlobalAssets,
  actionUpdate: AppearanceGlobalAssetsActions.updateAppearanceGlobalAssets,
  actionGetDraftId: AppearanceGlobalAssetsActions.getDraftId,
  storeNode: storeStructure.AppearanceGlobalAssets,
  title: 'Global assets',
  fields: [
    {
      attributeName: 'logoId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo',
      helpText: 'Logo image above the main panel.',
      fileType: ['image/*'],
    },
    {
      attributeName: 'sloganId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Slogan',
      helpText: 'Slogan image above the main panel.',
      fileType: ['image/*'],
    },
    {
      attributeName: 'backgroundSoundId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Background Sound',
      helpText: 'Background music for the home scene.',
      fileType: ['audio/*'],
    },
    {
      attributeName: 'backgroundImageId',
      type: FormInputTypes.BACKGROUND,
      label: 'Background Image',
      helpText: 'Background image for the home scene.',
      fileType: ['image/*'],
    },
    {
      attributeName: 'videoBackgroundImageId',
      type: FormInputTypes.BACKGROUND,
      label: 'Video Background Image',
      helpText: 'Background image for the background used in 180 videos/cameras.',
      fileType: ['image/*'],
    },
    {
      attributeName: 'flatVideoBackgroundImageId',
      type: FormInputTypes.BACKGROUND,
      label: 'Flat Video Background Image',
      helpText: 'Background image for the background used in flat videos/cameras.',
      fileType: ['image/*'],
    },
    {
      attributeName: 'mobileCoverPictureId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Cover Picture',
      helpText: 'The main panel cover picture. This attribute is for mobile platform.',
      fileType: ['image/*'],
    },
    {
      attributeName: 'mobileCoverLogoId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Cover Logo',
      helpText: 'The main panel cover logo. This attribute is for mobile platform.',
      fileType: ['image/*'],
    },
    {
      attributeName: 'mobileCoverSloganId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Cover Slogan',
      helpText: 'The main panel cover slogan. This attribute is for mobile platform.',
      fileType: ['image/*'],
    },
  ],
};
